import { FC } from "react";

import { FullWidthVStack } from "@components/common";
import responsiveStyle from "@lib/theme/responsiveStyle";

import SenderAddress from "./SenderAddress";
import SenderInfo from "./SenderInfo";

const SenderFormFields: FC = () => (
  <FullWidthVStack spacing={responsiveStyle({ mobile: "1.625rem", desktop: "1.5rem" })}>
    <SenderInfo />
    <SenderAddress />
  </FullWidthVStack>
);
export default SenderFormFields;
